const marketRules = {
  BE: {
    start: new Date("2026-06-04T08:00:00+02:00"),
    end: new Date("2026-06-30T23:59:59+02:00"),
  },
  FR: {
    start: new Date("2026-06-04T08:00:00+02:00"),
    end: new Date("2026-06-23T23:59:59+02:00"),
  },
  IT: {
    start: new Date("2026-06-04T08:00:00+02:00"),
    end: new Date("2026-07-03T17:29:59+02:00"),
  },
  US: {
    start: new Date("2025-11-26T00:00:00-05:00"),
    end: new Date("2025-12-04T23:59:59-05:00"),
  },
  WW: {
    start: new Date("2025-12-04T00:00:00+01:00"),
    end: new Date("2026-01-02T23:59:59+01:00"),
  },
};

function hasPrivateSales() {
  const cookie = document.cookie.split(';').some((item) => item.trim().startsWith('private_sales'));

  const hasPrivateSalesCookie = document.cookie.split(';').some((item) => item.trim().startsWith('private_sales=true'));
  const hasPrivateSalesMetafield = window.customerPrivateSales === "gid://shopify/Metaobject/18014994737" || window.customerPrivateSales === "gid://shopify/Metaobject/18014961969";

  if (hasPrivateSalesCookie || hasPrivateSalesMetafield) {
    const now = new Date();
    const country = window.countryCode || "WW";
    const market = marketRules[country] || marketRules["WW"];

    if (now >= market.start && now <= market.end) {
      return true;
    }
  }

  return false;
}

function managePricesPrivateSales() {
  document.querySelectorAll('[product-private-price]').forEach((privatePriceEl) => {
    const originalPriceEl = document.querySelectorAll('[product-price][product-id="' + privatePriceEl.getAttribute('product-id') + '"]');

    originalPriceEl.forEach(priceEl => priceEl.classList.add("product-price__compare", "text-sm"));

    privatePriceEl.style.display = 'inline';
  });

  document.querySelector("[cart-price]")?.style.setProperty("display", "none");
  document.querySelector("[cart-private-price]")?.style.setProperty("display", "inline");
}

function updateCartAttributes() {
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      attributes: {
        "current_datetime": Date.now().toString(),
        "private_sales": true
      }
    })
  })
  .then(response => response.json())
  .then(data => console.log(data));
}

document.addEventListener("DOMContentLoaded", () => {
  const params = new URLSearchParams(window.location.search);

  if (params.get("private_sales") === "052026_db48q93p") { // TODO: inserirlo come proprietà nei settings
    const country = window.countryCode || "WW";
    const market = marketRules[country] || marketRules["WW"];

    const cookie = "private_sales=true; expires=" + market.end.toUTCString() + "; path=/";
    document.cookie = cookie;
  }

  window.enablePrivateSales = hasPrivateSales();

  if (window.enablePrivateSales) {
    managePricesPrivateSales();

    // Manage product page original price
    setTimeout(() => {
      const originalPriceElProduct = document.querySelector('[product-private-price]')?.closest('div')?.nextElementSibling?.querySelector('.product-price__amount');
      originalPriceElProduct?.classList.add("product-price__compare");

      updateCartAttributes();
    }, 125);
  }
});

document.addEventListener("ajaxinate:loaded", () => {
  if (window.enablePrivateSales) {
    managePricesPrivateSales();
  }
});
